module.exports = __webpack_public_path__ + "assets/img_rainbow-grocery.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/img_rainbow-grocery.jpg
 ** module id = 130
 ** module chunks = 1
 **/